
import classnames from 'classnames';
import { InputText as PrimeInputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import useProcessRules from 'src/hooks/useProcessRules';
import CustomErrorMessage from './CustomErrorMessage';
import { processDisabled } from './funciones';
import InputLabel from './InputLabel';

const InputText = ({ input }) => {
  const methods = useFormContext();
  const tipoIdentificacion = useWatch({
    control: methods.control,
    name: 'tipoIdentificacion',
    defaultValue: 'NOTHING',
  });
  const [type, setType] = useState('text');
  const { loading, processValidations } = useProcessRules(input);

  useEffect(() => {
    setType(input.subType);
    if (input.name === 'identificacion') {
      if (tipoIdentificacion && tipoIdentificacion?.includes('PASAPORTE')) {
        setType('text');
      } else {
        setType('tel');
      }
    }
  }, [input.name, input.subType, tipoIdentificacion]);
  const { control, formState: { errors } } = methods;


  // Obtiene las validaciones específicas ingresadas en la base de datos y/o agragadas en el campo.
  const rules = processValidations();
  console.log("input", input.name, input);

  return (
    <>
      <span className="p-input-icon-right w-100">
        {loading &&
          <i className="pi pi-spin pi-spinner" style={{ zIndex: 1 }} />}
        <span className="p-float-label">
          <Controller
            control={control}
            name={input.name}
            //defaultValue={watch(input.name) ? watch(input.name) : ''}
            defaultValue=""
            rules={rules}
            render={({ field: { onChange, value } }) => (
              <>
                <PrimeInputText
                  value={value}
                  className={classnames({
                    'w-100': true,
                    'p-invalid': !!errors[input.name],
                  })}
                  required={input.required}
                  maxLength={input.length}
                  type={type}
                  inputMode={(type === 'tel' ? 'numeric' : 'text')}
                  contentEditable={input.editable}
                  disabled={processDisabled(input, loading)}
                  onChange={({ currentTarget, ...res }) => {
                    console.log("currentTarget", currentTarget, res);
                    if (input.onSave && input.onSave.includes('toUpperCase')) {
                      onChange(currentTarget.value.toUpperCase());
                    } else {
                      onChange(currentTarget.value);
                    }
                  }}
                  onKeyDown={(evt) => {
                    if (input.subType === 'number' && 'Ee.+-'.includes(evt.key)) {
                      evt.preventDefault();
                    }
                  }}
                />
              </>
            )}
          />
          <InputLabel input={input} rules={rules} />
        </span>
      </span>
      <CustomErrorMessage name={input.name} />
    </>
  );
};

export default InputText;
